import React from 'react'
import { l } from '@manychat/manyui'

import * as triggerStyle from './Trigger.styles'

export const TriggerDisabledLabel = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) {
    return null
  }

  return (
    <view style={triggerStyle.DisabledLabelStyle}>
      <richtext style={triggerStyle.DisabledLabelTextStyle} text={l.translate('Disabled')} />
    </view>
  )
}
